import React from "react";
const bgStyle = {
  textAlign: "center",
  minHeight: "80vh",
  // marginTop: '10%',
  width: "100%",
  backgroundImage:
    "url(https://thewebman.github.io/coronapwa/images/maskup.svg)",
  backgroundColor: "#A9D8FF",
  backgroundPosition: "center",
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
};

function Info() {
  return <div style={bgStyle}></div>;
}

export default Info;
